import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, Heart, CircleUserRound } from "lucide-react";
import { useWishlistCount } from "@/lib/wishlist";

// App-like 3-tab mobile bottom nav (guest-facing). Local wishlist/profile — no login.
export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const wishCount = useWishlistCount();

  const Tab = ({ to, label, Icon, testid, badge }) => {
    const active = to === "/stays" ? pathname.startsWith("/stays") : pathname === to;
    return (
      <Link to={to} data-testid={testid} aria-current={active ? "page" : undefined}
        className={`relative flex flex-col items-center justify-center gap-1 flex-1 min-h-[52px] py-1.5 text-[0.68rem] transition-colors active:scale-95 ${active ? "text-brand font-semibold" : "text-ink-faint font-normal"}`}>
        <span className="relative">
          <Icon className="w-6 h-6" strokeWidth={active ? 2.2 : 1.8} aria-hidden="true" />
          {badge > 0 && (
            <span className="absolute -top-1 -right-2 min-w-[15px] h-[15px] px-0.5 rounded-full bg-brand text-white text-[9px] font-bold flex items-center justify-center">{badge}</span>
          )}
        </span>
        {label}
      </Link>
    );
  };

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-t border-black/10 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
      <div className="flex items-stretch">
        <Tab to="/stays" label="Explore" Icon={Search} testid="bottomnav-explore" />
        <Tab to="/wishlist" label="Wishlists" Icon={Heart} testid="bottomnav-wishlist" badge={wishCount} />
        <Tab to="/profile" label="Profile" Icon={CircleUserRound} testid="bottomnav-profile" />
      </div>
    </nav>
  );
};

export default MobileBottomNav;
